<template>
  <div>
    <validation-observer v-slot="{}">
      <v-simple-table class="table-layout pa-5">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="th-id">STT</th>
              <th>Nguồn</th>
              <th>Nhóm sản phẩm</th>
              <th>Độ ưu tiên</th>
              <th v-if="showAction">Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, index) in prioritySettings">
              <tr :key="item.id">
                <td>{{ item.stt + index + 1 }}</td>
                <td>{{ getContactSourceName(_.get(item, 'contactSourceId', '')) }}</td>
                <td>{{ getProductGroupName(_.get(item, 'productGroupId', '')) }}</td>
                <td
                    style="width: 20%"
                    v-if="!item.showEdit.priority"
                    @dblclick="enableShowEdit(item, 'priority')"
                >{{ _.get(item, 'priority') }}</td>

                <td v-else style="width: 20%">
                  <validation-provider
                      v-slot="{ errors }"
                      :rules="{ required: true, numeric: true, regex: /^[0-9]*$/, min_value: 0 }"
                      name="Độ ưu tiên"
                      class="d-flex flex-wrap"
                      :customMessages="{ numeric: 'Vui lòng nhập số 0 hoặc nguyên dương' }"
                  >
                    <v-text-field
                        @keydown.space.prevent
                        @dblclick="enableShowEdit(item, 'priority')"
                        outlined
                        v-model="item.priority"
                        color="#7367F0"
                        :error-messages="errors"
                        @keyup.enter="updatePrioritySetting(item, errors)"
                        :readonly="!checkAuthorization('priority-setting_update')"
                    />
                  </validation-provider>
                </td>

                <td v-if="showAction">
                  <div class="action">
                    <v-tooltip bottom v-if="checkAuthorization('user_update')">
                      <template v-slot:activator="{ on }">
                        <v-btn class="mr-2"
                               @click="editItem(item)" icon small color="primary" dark v-on="on"><v-icon>mdi-pencil</v-icon></v-btn>
                      </template>
                      <span>Cập nhật</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn @click="onClickDelete(item)" icon small color="default" v-on="on"><v-icon>mdi-delete</v-icon></v-btn>
                      </template>
                      <span>Xóa</span>
                    </v-tooltip>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </validation-observer>
  </div>
</template>
<script>
  import RepositoryFactory from '../../../repositories/RepositoryFactory'
  const PrioritySettingRepository = RepositoryFactory.get('priority_setting')
  export default {
    props: {
      filterForm: {
        type: Object,
        default: () => {},
      },
      prioritySettings: {
        type: Array,
        default: () => [],
      },
      contactSourceList: {
        default: () => ([]),
      },
      productGroupList: {
        default: () => ([]),
      },
    },
    data () {
      return {
        selectedItem: {},
        modalAlert: false,
        errorMessage: '',
      }
    },
    computed: {
      showAction () {
        return 0;
      }
    },
    methods: {
      editItem (item) {
        this.selectedItem = item
        Bus.$emit('priority-setting-show-form', this.selectedItem)
      },
      async onClickDelete (item) {
        this.$swal({
          title: 'Xóa',
          text: 'Bạn có thực sự muốn xóa ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ',
        }).then(async (result) => {
          if (result.value) {
            this.appLoadingData(true)
            const respond = await PrioritySettingRepository.delete(item.id)
            this.appLoadingData(false)
            if (_.get(respond, 'success', false)) {
              this.$swal({
                title: 'Đã xóa thành công !',
                confirmButtonText: 'Đồng ý',
              },
              ).then(() => {
                Bus.$emit('priority-setting-list-reload')
              })
            } else {
              this.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: _.get(respond, 'message', ''),
              })
            }
          }
        })
      },
      async updatePrioritySetting (item, errors) {
        if (errors.length) {
          return
        }
        const body = {
          priority: +item?.priority,
          contactSourceId: item.contactSourceId,
          productGroupId: item.productGroupId
        }
        this.appLoadingData(true)
        const response = await PrioritySettingRepository.update(item?.id, body)
        this.appLoadingData(false)
        if (response.success) {
          this.$swal({
            title: 'Cập nhật thành công !',
            confirmButtonText: 'Đồng ý',
            timer: 1000
          });
          Bus.$emit('priority-setting-list-reload')
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi!',
            text: _.get(response, 'message', '')
          });
        }
      },
      enableShowEdit (item, attr) {
        if (!this.checkAuthorization('priority-setting_update')) {
          this.$swal({
            type: 'error',
            title: 'Cảnh báo!',
            text: "Bạn không có quyền cập nhật. Vui lòng liên hệ admin!"
          });
          return
        }
        item.showEdit[attr] = !item.showEdit[attr]
      },
      getContactSourceName (sourceId) {
        return this.contactSourceList.find(item => item.id == sourceId)?.name || ''
      },
      getProductGroupName (groupId) {
        return this.productGroupList.find(item => item.id == groupId)?.name || ''
      }
    },
  }
</script>

<style scoped>
.table-layout {
  text-align: center;
}
.table-layout th {
  text-align: center !important;
  min-width: 130px;
  font-size: 14px;
  font-weight: 500 !important;
  position: relative;
}
.table-layout th.th-id {
  width: 50px;
}

.table-layout tbody tr {
  height: 80px;
}
.table-layout tbody tr:hover {
  background: rgba(0, 0, 0, 0.11) !important;
}
/deep/ .v-data-table td, .v-data-table th {
  border: thin solid rgba(0, 0, 0, 0.12);
}
</style>
